const colors = {
  primaryDark: "#22283C",
  secondaryDark: "#2C334A",
  tertiaryDark: "#29314B",
  borderStroke: "#907CFF",
  headings: "#FF725E",
  text: "#EAEAEA",
};
export default colors;
